import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconArrowSlideIn32(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={32}
            height={32}
            className={customClassName}
            name="IconArrowSlideIn32"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                d="M20.282 26.094c-2.177 0-4.193-.692-5.842-1.864l1.632-1.79a7.693 7.693 0 1 0-.658-12.395l-1.786-1.628a10.05 10.05 0 0 1 6.654-2.509c5.574 0 10.093 4.519 10.093 10.093s-4.519 10.092-10.093 10.093m-8.426-5.808a1.2 1.2 0 0 1-1.696-1.697l1.365-1.365H2.951a1.201 1.201 0 0 1 0-2.4h8.59l-1.382-1.383a1.2 1.2 0 0 1 1.697-1.697l4.272 4.27-.772.772q-.073.09-.163.163z"
            />
        </svg>
    );
}
export default memo(IconArrowSlideIn32);
